function hideWholesaleFromCarousel() {
  const rechargeCart = document.querySelector('#recharge-storefront-experiences__cart-drawer');
  if (!rechargeCart?.shadowRoot) return;
  
  const shadowRoot = rechargeCart.shadowRoot;
  const carouselItems = shadowRoot.querySelectorAll('[role="group"][aria-roledescription="slide"]');
  if (carouselItems.length === 0) return;
  
  let needsProcessing = false;
  carouselItems.forEach(item => {
    const titleElement = item.querySelector('.text-storefront-drawer-foreground.font-semibold');
    if (titleElement?.textContent.toLowerCase().includes('wholesale') && item.style.display !== 'none') {
      needsProcessing = true;
    }
  });
  
  if (!needsProcessing) return;
  
  let hiddenCount = 0;
  carouselItems.forEach(item => {
    const titleElement = item.querySelector('.text-storefront-drawer-foreground.font-semibold');
    if (titleElement?.textContent.toLowerCase().includes('wholesale')) {
      item.style.display = 'none';
      hiddenCount++;
    }
  });
  
  const visibleItems = carouselItems.length - hiddenCount;
  if (visibleItems <= 1) {
    shadowRoot.querySelector('[data-slot="carousel-previous"]')?.style.setProperty('display', 'none');
    shadowRoot.querySelector('[data-slot="carousel-next"]')?.style.setProperty('display', 'none');
  }
}

new MutationObserver(hideWholesaleFromCarousel).observe(document.body, { childList: true, subtree: true });
setInterval(hideWholesaleFromCarousel, 500);